import { config } from 'data';
import { invoiceService } from 'services';
import { useQuery } from 'hooks';
import { Uuid } from 'types/common';

const getInvoiceQuery = (id?: Uuid) => ({
  queryKey: [config.INVOICE_QUERY_KEY, id],
  queryFn: () => id ? invoiceService.getInvoice(id) : null,
});

const useInvoiceQuery = (id?: Uuid) => useQuery(getInvoiceQuery(id));

export { getInvoiceQuery };

export default useInvoiceQuery;
